import Vue, { VueConstructor } from 'vue';
import { typedStore } from '@/store';

export default function install(vue: VueConstructor<Vue>) {
    vue.prototype.$typedStore = typedStore;
}
